import { render, staticRenderFns } from "./OverlayPortalTarget.vue?vue&type=template&id=61926918&"
import script from "./OverlayPortalTarget.vue?vue&type=script&lang=js&"
export * from "./OverlayPortalTarget.vue?vue&type=script&lang=js&"
import style0 from "./OverlayPortalTarget.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports